export default __webpack_public_path__ + "locales/sk/HotkeysPanel.json?hash=6011e549650bcc282d1ad36ae21251d8";